interface Props {
  template: string;
}

export function PromptTemplate({ template }: Props) {
  // Parse {variable} placeholders and wrap them in <span class="var">
  const parts = template.split(/(\{[^}]+\})/g);

  return (
    <div className="prompt-template">
      {parts.map((part, i) =>
        part.startsWith('{') && part.endsWith('}') ? (
          <span key={i} className="var">{part}</span>
        ) : (
          <span key={i}>{part}</span>
        ),
      )}
    </div>
  );
}
